import React from "react";

import ImageField from "../../TableEntities/Fields/ImageField";

export default function ImageComponent({ entity, value }) {
  return <ImageField onDoubleClick={() => null} entity={entity} value={value} />;
}
